export default __webpack_public_path__ + "static/media/kitchen3-afterF-1440w.a4c333b0.png";